import { defaultEnvironmentConfigs, EEnvironmentName, IEnvironment } from './environment.defaults';

export const environment: IEnvironment = {
  ...defaultEnvironmentConfigs,
  apiUrl: 'https://campaign-api.shikenso.com/',
  campaignCreationByPromptEnabled: false,
  clarity: {
    enabled: true,
    projectId: 'v08c1nu4b3',
  },
  environmentName: EEnvironmentName.production,
  eventTrackingEnabled: true,
  firebaseConfig: {
    apiKey: 'AIzaSyC0q8GfgDoQulaXzFxjoQVVRuWdfT86eLo',
    appId: '1:840360739308:web:75ab3da6a1b461035840c9',
    authDomain: 'campaignmanagementprod.firebaseapp.com',
    messagingSenderId: '840360739308',
    projectId: 'campaignmanagementprod',
    storageBucket: 'campaignmanagementprod.firebasestorage.app',
  },
  hubspot: {
    enabled: false,
    portalId: '145496113',
  },
  mcpServerUrl: 'https://mcp.campaign-api.shikenso.com/mcp',
  sentry: {
    dsn: 'https://8aa8b9b468239f8bf58fc8a101e84e82@o4509744862134272.ingest.de.sentry.io/4510023326826576',
    profilesSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
  },
};
